import axios from 'axios';
import React, { useEffect, useState, Suspense } from 'react';

// img
import instagram from "../img/instagram.svg"
import snapchat from "../img/snapchat.svg"
import tiktok from "../img/tiktok.svg"
import girl from "../img/maskgirl.png"

// Components
import CountryDropdown from '../Component/countrydropdown';
import { useLocation } from 'react-router-dom';

// Lazy load components
const Header = React.lazy(() => import('../Component/Header'));
const Footer2 = React.lazy(() => import('../Component/Footer2'));
const Loading = React.lazy(() => import('../Component/Loading'));

const Collab = () => {
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: '' });

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const ref = params.get("ref");
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contactNumber: '',
        countryCode: '+91',
        city: '',
        instagram: '',
        snapchat: '',
        tiktok: ''
    });

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});


    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 10);
    }, []);

    // Toast notification effect
    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => {
                setToast({ show: false, message: '', type: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
    };

    const validateForm = () => {
        const newErrors = {};

        // Name validation
        if (!formData.name.trim()) {
            newErrors.name = 'Name is required';
        }

        // Email validation
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Email address is required';
        }

        // Contact number validation - REQUIRED
        if (!formData.contactNumber.trim()) {
            newErrors.contactNumber = 'Contact number is required';
        } else if (!/^[0-9]+$/.test(formData.contactNumber)) {
            newErrors.contactNumber = 'Only numbers are allowed';
        }

        // city validation
        if (!formData.city.trim()) {
            newErrors.city = 'City is required';
        }

        // Social media validation - at least one required
        // Check if there's actual content (not empty and not just "@")
        const hasInstagram = formData.instagram.trim() && formData.instagram.trim() !== '@';
        const hasSnapchat = formData.snapchat.trim() && formData.snapchat.trim() !== '@';
        const hasTiktok = formData.tiktok.trim() && formData.tiktok.trim() !== '@';

        const hasSocialMedia = hasInstagram || hasSnapchat || hasTiktok;

        if (!hasSocialMedia) {
            newErrors.socialMedia = 'At least one social media handle is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // For contact number, only allow numeric input
        if (name === 'contactNumber') {
            // Only update if value is empty or contains only numbers
            if (value === '' || /^[0-9]+$/.test(value)) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
        }
        // For social media fields, auto-add @ prefix
        else if (['instagram', 'snapchat', 'tiktok'].includes(name)) {
            let newValue = value;

            // If field is not empty and doesn't start with @, add it
            if (newValue.length > 0 && !newValue.startsWith('@')) {
                newValue = '@' + newValue.replace(/@/g, '');
            }

            // If user tries to delete @ and there's content after it, keep the @
            if (newValue.length > 0 && !newValue.startsWith('@')) {
                newValue = '@' + newValue;
            }

            // If value is just @ or empty, allow it
            setFormData(prev => ({
                ...prev,
                [name]: newValue
            }));
        }
        else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }

        // Clear social media error if any social field is filled
        if (['instagram', 'snapchat', 'tiktok'].includes(name) && value.trim()) {
            setErrors(prev => ({
                ...prev,
                socialMedia: ''
            }));
        }
    };

    const handleBlur = (field) => {
        setTouched(prev => ({
            ...prev,
            [field]: true
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setTouched({
            name: true,
            email: true,
            contactNumber: true,
            city: true,
            instagram: true,
            snapchat: true,
            tiktok: true
        });

        if (!validateForm()) {
            return;
        }

        // Helper function to strip @ from social media handles
        const stripAt = (handle) => handle.replace(/^@/, '').trim();

        const payload = {
            type: ref === "plexus" ? "Plexus Website" : "LOL Website",
            name: formData.name,
            email: formData.email,
            city: formData.city,
            number: `${formData.countryCode}${formData.contactNumber}`,
            ...(formData.instagram && formData.instagram !== '@' && { instaId: stripAt(formData.instagram) }),
            ...(formData.snapchat && formData.snapchat !== '@' && { snapId: stripAt(formData.snapchat) }),
            ...(formData.tiktok && formData.tiktok !== '@' && { tiktokId: stripAt(formData.tiktok) }),
        };

        setSubmitting(true);

        try {
            const response = await axios.post(
                "https://api.lolcards.link/api/collab/web/add",
                payload
            );

            if (response.data) {
                showToast('Your request send successfully!', 'success');

                setFormData({
                    name: '',
                    email: '',
                    contactNumber: '',
                    countryCode: '+91',
                    city: '',
                    instagram: '',
                    snapchat: '',
                    tiktok: ''
                });

                setTouched({});
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            showToast('Failed to submit form. Please try again.', 'error');
        } finally {
            setSubmitting(false);
        }
    };



    if (loading) {
        return (
            <Suspense fallback={<div></div>}>
                <Loading />
            </Suspense>
        );
    }

    return (
        <Suspense fallback={<div><Loading /></div>}>
            <div>
                <Header activeLink={''} />
                <div className='rounded-top-5 overflow-hidden'>
                    <div className='title-bg d-flex align-items-center justify-content-center'>
                        <div className='text-center' style={{ marginTop: "-120px" }}>
                            <h1 className='title-text BwGradualBold text-white m-0 px-1'>App</h1>
                            <h1 className='title-text BwGradualBold text-white'>Collaboration</h1>
                        </div>
                    </div>
                    <div className='my-3' >
                        <div className='shadow mx-auto rounded-5 bg-white position-relative'
                            style={{
                                marginTop: "-150px",
                                maxWidth: '750px',
                                width: '80%',
                                minHeight: "500px",
                                padding: '40px 30px'
                            }}>

                            <div className='pb-4 text-center' style={{ color: "#ACACAC" }}>
                                let's take this to new heights
                            </div>

                            <div className='w-100 d-flex flex-column flex-lg-row align-items-center gap-4'>

                                <div className='collab-form'>
                                    {/* Form */}
                                    <form onSubmit={handleSubmit} className=''>
                                        {/* Name Field */}
                                        <div className='form-group'>
                                            <label className='form-label'>
                                                Name<span className='required-star'>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                name='name'
                                                value={formData.name}
                                                onChange={handleChange}
                                                onBlur={() => handleBlur('name')}
                                                placeholder='Name'
                                                className={`form-input ${touched.name && errors.name ? 'error' : ''}`}
                                                disabled={submitting}
                                            />
                                            {touched.name && errors.name && (
                                                <span className='error-message'>{errors.name}</span>
                                            )}
                                        </div>

                                        {/* Email Field */}
                                        <div className='form-group'>
                                            <label className='form-label'>
                                                Email<span className='required-star'>*</span>
                                            </label>
                                            <input
                                                type='email'
                                                name='email'
                                                value={formData.email}
                                                onChange={handleChange}
                                                onBlur={() => handleBlur('email')}
                                                placeholder='Email'
                                                className={`form-input ${touched.email && errors.email ? 'error' : ''}`}
                                                disabled={submitting}
                                            />
                                            {touched.email && errors.email && (
                                                <span className='error-message'>{errors.email}</span>
                                            )}
                                        </div>

                                        {/* Contact Number Field with Custom Dropdown */}
                                        <div className='form-group'>
                                            <label className='form-label'>
                                                Contact number<span className='required-star'>*</span>
                                            </label>
                                            <div className='contact-input-wrapper'>
                                                <CountryDropdown
                                                    name='countryCode'
                                                    value={formData.countryCode}
                                                    onChange={handleChange}
                                                />
                                                <div className='w-100'>
                                                    <input
                                                        type='tel'
                                                        name='contactNumber'
                                                        value={formData.contactNumber}
                                                        onChange={handleChange}
                                                        onBlur={() => handleBlur('contactNumber')}
                                                        placeholder='Phone number'
                                                        disabled={submitting}
                                                        className={`form-input contact-input ${touched.contactNumber && errors.contactNumber ? 'error' : ''}`}
                                                    />
                                                    {touched.contactNumber && errors.contactNumber && (
                                                        <span className='error-message'>{errors.contactNumber}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* City Field */}
                                        <div className='form-group'>
                                            <label className='form-label'>City<span className='required-star'>*</span></label>
                                            <input
                                                type='text'
                                                name='city'
                                                value={formData.city}
                                                onChange={handleChange}
                                                placeholder='City'
                                                className={`form-input ${touched.city && errors.city ? 'error' : ''}`}
                                                disabled={submitting}
                                            />
                                            {touched.city && errors.city && (
                                                <span className='error-message'>{errors.city}</span>
                                            )}
                                        </div>

                                        {/* Social Media Handles */}
                                        <div className='form-group'>
                                            <label className='form-label'>
                                                Social media handle<span className='required-star'>*</span>
                                            </label>

                                            {/* Instagram */}
                                            <div className='social-input-container' >
                                                <div className='social-icon-inside'>
                                                    <img src={instagram} alt="instagram" />
                                                </div>
                                                <div className='line '> </div>
                                                <input
                                                    type='text'
                                                    name='instagram'
                                                    value={formData.instagram}
                                                    onChange={handleChange}
                                                    onBlur={() => handleBlur('instagram')}
                                                    placeholder='@username'
                                                    className={`form-input social-input-with-icon ${errors?.socialMedia ? "border border-danger" : ""
                                                        }`}
                                                    disabled={submitting}
                                                />
                                            </div>

                                            {/* Snapchat */}
                                            <div className='social-input-container'>
                                                <div className='social-icon-inside'>
                                                    <img src={snapchat} alt="snapchat" />
                                                </div>
                                                <div className='line '> </div>
                                                <input
                                                    type='text'
                                                    name='snapchat'
                                                    value={formData.snapchat}
                                                    onChange={handleChange}
                                                    onBlur={() => handleBlur('snapchat')}
                                                    placeholder='@username'
                                                    className={`form-input social-input-with-icon ${errors?.socialMedia ? "border border-danger" : ""
                                                        }`}
                                                    disabled={submitting}
                                                />
                                            </div>

                                            {/* TikTok */}
                                            <div className='social-input-container'>
                                                <div className='social-icon-inside'>
                                                    <img src={tiktok} alt="tiktok" />
                                                </div>

                                                <div className='line '> </div>
                                                <input
                                                    type='text'
                                                    name='tiktok'
                                                    value={formData.tiktok}
                                                    onChange={handleChange}
                                                    onBlur={() => handleBlur('tiktok')}
                                                    placeholder='@username'
                                                    className={`form-input social-input-with-icon ${errors?.socialMedia ? "border border-danger" : ""
                                                        }`}
                                                    disabled={submitting}
                                                />
                                            </div>

                                            {errors.socialMedia && (
                                                <span className='error-message'>{errors.socialMedia}</span>
                                            )}

                                            {/* Submit Button with Loading Spinner */}
                                            <button
                                                type='submit'
                                                className='submit-button'
                                                disabled={submitting}
                                            >
                                                {submitting ? (
                                                    <div className="custom-spinner" style={{ borderTopColor: "#fff" }} />
                                                ) : (
                                                    'Submit'
                                                )}
                                            </button>
                                        </div>
                                    </form>

                                </div>


                                {/* <div className='glass-right rounded-5 d-flex flex-column align-items-center justify-content-around text-center p-3'
                                    style={{
                                        width: "300px",
                                        height: "400px",
                                        background: "rgba(255, 107, 107, 0.2)",
                                        border: "1px solid rgba(255, 107, 107, 0.45)",
                                        backdropFilter: "blur(10px)",
                                        WebkitBackdropFilter: "blur(10px)",
                                        boxShadow:
                                            "0 4px 20px rgba(255, 107, 107, 0.15), inset 0 1px 0 rgba(255,255,255,0.2)",
                                        transition: "all 0.3s ease",
                                    }}>

                                    <div className='rounded-circle bg-white overflow-hidden'
                                        style={{ width: "120px", height: "120px", border: "5px solid #fa5353" }}>
                                        <img src={collab} alt="collab" className="img-fluid" />
                                    </div>


                                    <h6 className='text-secondary'>
                                        If you're interested in collaborating with us for a merch capsule, co-branding, promotion, advertising, sponsorships, or anything in between, please email us directly at help@lolcards.link.
                                    </h6>

                                </div> */}


                            </div>

                            <div className='position-absolute d-none d-sm-block' style={{ left: "-80px", top: "-30px" }} >
                                <img src={girl} alt='avatar' className='img-fluid' style={{ width: "150px", height: "150px" }} />
                            </div>
                        </div>
                    </div>
                    <Footer2 />
                </div>

                {/* Toast Notification */}
                {toast.show && (
                    <div className={`toast-notification ${toast.type} ${toast.hiding ? 'hiding' : ''}`}>
                        <div className="toast-icon">
                            {toast.type === 'success' ? (
                                <svg viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            ) : (
                                <svg viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                            )}
                        </div>
                        <div className="toast-content">
                            <p className="toast-title">
                                {toast.type === 'success' ? 'Collab request sent!' : 'Error'}
                            </p>
                            <p className="toast-message">{toast.message}</p>
                        </div>
                        <button
                            className="toast-close"
                            onClick={() => setToast({ show: false, message: '', type: '' })}
                            aria-label="Close"
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                )}
            </div>
        </Suspense>
    );
};

export default Collab;